import { mediaQuery } from 'constants/ui';

export const backButtonStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  width: 'fit-content',
  whiteSpace: 'nowrap',
  fontFamily: ({ typography }) => typography.fontFamily,
  color: ({ palette }) => `${palette.text.primary} !important`,
  transition: 'opacity 0.3s ease',

  '&:hover': {
    textDecoration: 'none !important',
    opacity: 0.7,
  },

  // The rotated chevron's ink fills only ~8 of its 24-unit viewBox, so a 16px icon carries
  // ~5px of transparent slack on each side. Without this the glyph reads as indented from the
  // page's content column and twice as far from the label as the 7px gap intends.
  // The odd -5px is deliberate: the slack measures ~5.3px, so -6px would overhang the column.
  '& > svg': {
    marginLeft: '-5px',
    marginRight: '2px',
    color: ({ palette }) => palette.text.primary,
  },

  [mediaQuery.mobile]: {
    minHeight: '44px',
  },
};
